// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__X1Jp0","column":"Footer_column__C4KV3","copyright":"Footer_copyright__G_qSi","status":"Footer_status__2fPgY","banner":"Footer_banner__DLcVw"};